import { __rest } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const Quote = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-quote' }, props, { ref: ref, theme: theme, className: cn(['tend-ui-typography-quote', className]) })));
});
Quote.displayName = 'Quote';

export { Quote };
//# sourceMappingURL=Quote.js.map
